import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'

export const AnalyticsEmptyState = () => {
  return <NoResultsFound icon='filter' label='No matching results' />
}
